import React from "react";
import styles from "./BackGround.module.css";

export default function BackGround(props) {
    return <section className={styles.bg}>{props.children}</section>;
}